import { render, staticRenderFns } from "./GTrendAnalysisGrowthMindsetMapChart.vue?vue&type=template&id=bd63a298&scoped=true&"
import script from "./GTrendAnalysisGrowthMindsetMapChart.vue?vue&type=script&lang=ts&"
export * from "./GTrendAnalysisGrowthMindsetMapChart.vue?vue&type=script&lang=ts&"
import style0 from "./GTrendAnalysisGrowthMindsetMapChart.vue?vue&type=style&index=0&id=bd63a298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd63a298",
  null
  
)

export default component.exports